module.exports = __webpack_public_path__ + "static/media/dado-antropometrico-icon.a6c7ed9f.svg";